export default [
  {
    title: 'Dashboard',
    icon: 'fas fa-home',
    path: '/dashboard',
    view: 'Dashboard',
    dir: 'views/',
    menu: true,
    meta: {
      // role: ['Gerente'],
    }
  },

  /* {
    title: 'Configurações',
    icon: 'fas fa-cog',
    path: '/admin',
    dir: 'views/admin/',
    menu: true,
    meta: {
      // role: ['Nenhum']
    },
    items: [
      {
        path: '/usuario',
        view: 'Usuario',
        title: 'Usuário',
        menu: true,
        meta: {
          // role: ['Nenhum']
        }
      }
    ]
  }, */
  {
    title: 'Email',
    icon: 'fas fa-envelope',
    path: '/email/',
    dir: 'views/admin/Email/',
    menu: true,
    meta: {
      roles: ['BMPConfigFront.Admin']
    },
    items: [
      {
        path: 'emailsmtp',
        view: 'EmailSMTP',
        title: 'SMTP',
        menu: true,
        meta: {
          roles: ['BMPConfigFront.Admin']
        }
      },
      {
        path: 'emailtemplate',
        view: 'EmailTemplate',
        title: 'Template',
        menu: true,
        meta: {
          roles: ['BMPConfigFront.Admin']
        }
      }
    ]
  },
  {
    title: 'SMS',
    icon: 'fas fa-cog',
    path: '/admin',
    dir: 'views/admin/Sms/',
    menu: true,
    meta: {
      roles: ['BMPConfigFront.Admin']
    },
    items: [
      {
        path: '/parceirotalktelecom',
        view: 'ParceiroTalkTelecom',
        title: 'TalkTelecom',
        menu: true,
        meta: {
          roles: ['BMPConfigFront.Admin']
        }
      }
    ]
  },
  {
    title: 'Kraken',
    icon: 'fab fa-gitkraken',
    path: '/kraken',
    dir: 'views/admin/Kraken/',
    menu: true,
    meta: {
      roles: ['BMPConfigFront.Admin']
    },
    items: [
      {
        path: '/tabelafipe',
        view: 'TabelaFipe',
        title: 'Tabela Fipe',
        menu: true,
        meta: {
          roles: ['BMPConfigFront.Admin']
        }
      },
      {
        path: '/gravame',
        view: 'Gravame',
        title: 'Gravame',
        menu: true,
        meta: {
          roles: ['BMPConfigFront.Admin']
        }
      }
    ]
  }
]
